module.exports = __webpack_public_path__ + "static/atniort-b657095f3c2823a9c78b90878ea46aa6.png";